export enum SynchronizeType {
  AlwaysAsk = 'AlwaysAsk',
  Automatic = 'Automatic',
  Manual = 'Manual',
}
